import React from "react";
import PropTypes from "prop-types";
import { gridPath, findDuotoneSecondary, DUOTONE_OPACITY, ICON_GRID } from "../../utils/svgIcon";
import { restrokePath, hasStrokeWidth, STROKE } from "../../utils/strokeWidth";

/**
 * The icon drawn over the 24px keyline grid (2px padding, ⌀20 circle, 18 square,
 * 16x20 portrait, 20x16 landscape). Keylines and icon share one viewBox so they
 * line up exactly. Turn it off with SHOW_KEYLINES in IconDetail.js.
 * Line icons are drawn at the chosen stroke width.
 */
export const KeylinePreview = ({ icon, icons, strokeWidth }) => {
  const secondary = findDuotoneSecondary(icons, icon);
  const d = gridPath(icon.svg);
  const max = ICON_GRID;
  return (
    <svg
      className="keyline-preview"
      viewBox={`-0.5 -0.5 ${max + 1} ${max + 1}`}
      role="img"
      aria-label="Icon on the 24 pixel keyline grid"
    >
      <g className="keyline-preview__lines" fill="none">
        <rect x="0" y="0" width={max} height={max} />
        <path d={`M0 0L${max} ${max}M${max} 0L0 ${max}M${max / 2} 0V${max}M0 ${max / 2}H${max}`} />
        <rect x="2" y="2" width="20" height="20" className="keyline-preview__live" />
        <circle cx="12" cy="12" r="10" />
        <rect x="3" y="3" width="18" height="18" />
        <rect x="4" y="2" width="16" height="20" />
        <rect x="2" y="4" width="20" height="16" />
      </g>
      <g fill="currentColor">
        <path d={hasStrokeWidth(icon) ? restrokePath(d, strokeWidth) : d} />
        {secondary ? <path d={gridPath(secondary.svg)} opacity={DUOTONE_OPACITY} /> : null}
      </g>
    </svg>
  );
};

KeylinePreview.propTypes = {
  icon: PropTypes.object.isRequired,
  icons: PropTypes.array.isRequired,
  strokeWidth: PropTypes.number,
};

KeylinePreview.defaultProps = {
  strokeWidth: STROKE.base,
};

export default KeylinePreview;
